<template>
  <div class="list-wrap">
    <div class="tile is-parent">
      <div class="tile is-child flex-1">
        <article class="box">
          <p class="title">原文地址</p>
          <div class="block">
            <input type="text" class="input width-3" v-model="url">
            <span class="r-top">(目前只支持微博、微信的原文链接)</span>
            <label class="label"><input type="checkbox" v-model="isSelf">来源为本人帐号</label>
          </div>
          <div class="block desc" >
            <div v-if='articleId'><label for="id">ID: </label>{{articleId}}</div>
            <div v-if='sourceTypeName' class='margin-left-80'><label for="source">来源: </label>{{sourceTypeName}}</div>
            <div v-if='sourceName' class='margin-left-80'><label for="">账号: </label>{{sourceName}}</div>
          </div>
          <p class="title">内容类型</p>
          <div class="block">
            <span class="select">
               <select v-model="articleType" @change="articleTypeChange" :disabled="articleTypeDisable">
                <option value="0">图集</option>
                <option value="1">文章</option>
              </select>
            </span>
          </div>
          <button class="button is-info" @click="crawlContent">抓取</button>
        </article>
        <article class="box">
          <p class="title">关联ICON</p>
          <div class="block">
          <el-select v-model="bloggerId" filterable placeholder="请选择">
            <el-option
              v-for="item in iconList"
              :key="item.bloggerId"
              :label="item.name"
              :value="item.bloggerId">
            </el-option>
          </el-select>
          </div>
          <p class="title">内容配文</p>
          <div class="block">
            <textarea class="textarea inline-block" v-model="content"></textarea>
          </div>
          <p class="title">图片</p>
          <div class="block">
            <span class="button is-primary" id="js_imageUploadBtn_1" style="line-height: 30px;">上传图片</span>
            <span class="upload-img-tips">图片尺寸小于1M</span>
            <button v-if="!isSort" class="button is-success" style="margin-left: 20px;" @click="sortImage">排序</button>
            <button v-else="" class="button is-success" style="margin-left: 20px;" @click="sortImage">保存</button>
          </div>
          <draggable v-model="images" class="lightgallery block picture-container clearfix">
            <div :class="imgClassName(item)"
                 v-for="(item,index) in images" @click="onImagePreviewClick($event,index,images)">
              <div class="img-rel-wrap">
                <label class="checkbox-icon">
                  <input :disabled="item.type == 'processing' || item.type == 'appendIng'" type="checkbox" class="checkbox" v-model="item.isSelected" @click.stop="imageSelectClick('images',item,index)"/>
                </label>
                <image-component :image="item.image" :width="150" :height="150" :compress="1.2" ></image-component>
                <b v-if="item.type != 'processing' && item.type != 'appendIng'" class="delete-icon  cursor" @click.stop="imageRemoveClick('delete',item,index)">移除</b>
              </div>
              <p>
                <span v-if="item.tips" class="red-font">{{item.tips}}</span>
                <span v-else="">分值:{{item.score}}</span>
              </p>
            </div>
          </draggable>
        </article>
        <article class="box">
          <p class="title">被清洗图片: (点击加入后,图片将重新恢复进动态中展示)</p>
          <div class="block clearfix picture-container lightgallery">
            <div class="img-rel-container fleft" v-for="(item,index) in deletedImages" @click="onImagePreviewClick($event,index,deletedImages)">
              <div class="img-rel-wrap">
                <image-component :image="item.image" :width="150" :height="150" :compress="1.2" ></image-component>
                <b class="delete-icon cursor" @click.stop="imageRemoveClick('add',item,index)">加入</b>
              </div>
            </div>
          </div>
        </article>
        <div class="bock">
          <button class="button is-info" @click="saveArticle">保存</button>
          <button class="button is-warning" @click="goBackArticleList">返回</button>
          <button v-if="status !== '3'" class="button is-success" @click="doSaveRelease">保存并放行</button>
        </div>
      </div>
      <div class="flex-space"></div>
      <div class="tile is-child box flex-2" style="width: 750px;height: 1000px;">
        <p class="title">内容预览</p>
        <iframe id="previewIframe" style="width: 100%; height: 100%;overflow: scroll" :src="previewUrl"></iframe>
      </div>
    </div>
    <loading :text="loadingText" v-if="loading"></loading>
  </div>
</template>
<script type="text/babel">
import Uploader from 'COMMON/uploaderModule/uploader'
import {onImagePreviewClick} from 'UTILS/imagePreview'
import loading from 'COMMON/loading/main.vue'
import draggable from 'vuedraggable'

export default {
  components: {
    loading, draggable
  },
  data () {
    return {
      status: null,
      isSort: false,
      articleId: 0,
      articleType: 0,
      articleTypeDisable: false,
      url: '',
      isSelf: 1,
      content: '',
      iconList: [],
      bloggerId: '',
      bloggerName: '',
      images: [], // 已经被清洗过且保留的图片
      deletedImages: [], // 被过滤的图片
      previewUrl: '',
      feedId: null,
      loadingText: '内容正在抓取,请稍候...',
      loading: false,
      saveImages: {
        images: [], // 抓取符合规则的图片
        deletedImages: [], // 被清晰的图片
        processingImages: [], // 从被清晰的图片里选择的
        appendImages: []// 用户手动上传
      },
      articleId: '',
      sourceTypeName: '',
      sourceName: '',
      originData: {}// 原始总数据
    }
  },
  mounted () {
    this.articleType = this.$route.query.articleType ? this.$route.query.articleType : 0
    this.articleId = this.$route.query.articleId ? this.$route.query.articleId : 0
    this.status = this.$route.query.status
    if (this.$route.query.articleId) {
      let params = {
        articleId: this.articleId
      }
      HttpRequest.get('/admin.php?method=blogger.getArticle', params, true).then((response) => {
        this.originData = JSON.parse(JSON.stringify(response.data))
        this.content = response.data.content
        this.previewUrl = response.data.previewUrl
        this.url = response.data.url
        this.isSelf = response.data.isSelf ? 1 : 0
        this.bloggerName = response.data.bloggerName
        this.bloggerId = response.data.bloggerId + ''
        this.articleId = response.data.articleId
        this.sourceTypeName = response.data.sourceTypeName
        this.sourceName = response.data.sourceName

        // 如果有正在处理的从被清洗的图片里选择的,则拼接展示在imagse归类里
        _.each(response.data.processingImages, (item, index) => {
          item.type = 'processing'
          item.tips = '分值:正在计算中...'
          item.isSelected = false
        })
        // 如果有正在处理的手动上传的图片,则拼接展示在imagse归类里
        response.data.appendImages = response.data.appendImages ? response.data.appendImages : []
        _.each(response.data.appendImages, (item, index) => {
          item.type = 'appendIng'
          item.tips = '分值:正在计算中...'
          item.isSelected = false
        })
        let images = response.data.images.concat(response.data.processingImages.concat(response.data.appendImages))
        // 格式化抓取来符合规则的图片,images中前9张默认标记选中,
        _.each(images, (item, index) => {
          if (index < 9) {
            item.isSelected = true
          } else {
            item.isSelected = false
          }
        })
        this.images = images
        _.each(response.data.deletedImages, (item, index) => {
          item.isSelected = false
          item.tips = '分值:勾选保存后计算...'
        })
        this.deletedImages = response.data.deletedImages
        this.articleTypeDisable = true
      })
    }

    this.getIconList()
    this.$nextTick(() => {
      this.initBindUploadImageClick()
    })
  },
  methods: {
    // 上传图片绑定
    initBindUploadImageClick () {
      // 图集类型
      this.uploadMainBind('#js_imageUploadBtn_1', true, (response) => {
        let img = {
          image: response.images.info.path,
          width: response.images.info.width,
          height: response.images.info.height,
          tips: '分值:勾选保存后计算...',
          type: 'append'// 手动添加
        }
        if (_.where(this.images, {isSelected: true}).length < 9) {
          img.isSelected = true
        } else {
          img.isSelected = false
        }
        this.images.push(img)
      })
    },
    uploadMainBind (id, multiple, callBack) {
      // 绑定上传图片控件
      let params = {
        config: {
          pick: {
            id: id,
            multiple: multiple
          },
          server: process.env.VUE_APP_PLATFORM + '/admin.php?method=image.uploadImage',
          fileVal: 'image',
          fileSizeLimit: 1 * 1024 * 1024,
          fileSingleSizeLimit: 1 * 1024 * 1024
        },
        extensionField: {
          target: this
        },
        events: {
          onFilesQueued (files, uploaderObj) {
            return this.onFilesQueued && this.onFilesQueued(files, uploaderObj)
          },
          onSuccess (response, file, uploaderObj) {
            callBack && callBack(response.data)
          },
          onError (response, file, uploaderObj) {

          }
        }
      }
      new Uploader(params)
    },
    // 修改文章类型
    articleTypeChange () {
      this.initBindUploadImageClick()
    },
    // 更新选择的ICON
    updateIconSelected (data) {
      if (data) {
        this.bloggerId = data.bloggerId
      }
    },
    // 获取ICON列表
    getIconList () {
      HttpRequest.get('/admin.php?method=blogger.getAllIconList', {}, true).then((response) => {
        this.iconList = _.toArray(response.data)
      })
    },
    // 内容抓取
    crawlContent () {
      this.loading = true
      let params = {
        url: this.url
      }
      this.getCrawlContent(params)
      // 抓取后用feedId轮询
      let overtime = 0
      this.setIntervalTime = setInterval(() => {
        if (this.feedId != null) {
          let _params = {
            feedId: this.feedId
          }
          this.getCrawlContent(_params)
        } else {
          this.getCrawlContent(params)
        }
        overtime = overtime + 5000
        if (overtime > 300000) {
          clearInterval(this.setIntervalTime)
          this.loading = false
          this.$message('喔~~~,抓取超时了')
        }
      }, 5000)
    },
    getCrawlContent (params) {
      HttpRequest.get('/admin.php?method=blogger.crawl', params, true).then((response) => {
        if (response.data.success) {
          this.feedId = response.data.feedId
          // 如果抓回来内容,先展示
          if (response.data.content) {
            this.content = response.data.content
          }
        }
        // 该内容被抓取过,根据feedId跳转回内容池,能搜索出该feed
        if (response.data.isHad && response.data.feedId) {
          if (response.data.status == 2) {
            this.loading = false
            clearInterval(this.setIntervalTime)
            if (confirm('当前已有此条动态，点击查看')) {
              this.$router.push({
                name: 'contentPool',
                query: {searchFeedId: response.data.feedId}
              })
            }
          } else if (response.data.status == 1) {
            if (!confirm('当前动态正在抓取中,确定要重复抓取吗?')) {
              this.loading = false
              clearInterval(this.setIntervalTime)
            }
          }
        }
        if (response.data.success && response.data.status == 2) {
          this.originData = JSON.parse(JSON.stringify(response.data))
          this.loading = false
          clearInterval(this.setIntervalTime)
          this.previewUrl = response.data.previewUrl
          this.content = response.data.content
          _.each(response.data.images, (item, index) => {
            if (index < 9) {
              item.isSelected = true
            } else {
              item.isSelected = false
            }
          })
          this.images = response.data.images
          _.each(response.data.deletedImages, (item, index) => {
            item.isSelected = false
            item.tips = '分值:勾选保存后计算...'
          })
          this.deletedImages = response.data.deletedImages
          this.articleType = response.data.articleType
          this.articleTypeDisable = true
        }
      }, (response) => {
        this.$message('喔~~~,抓取失败了,你可以再试试')
      })
    },
    // 保存文章
    saveArticle () {
      this.getSaveImages()
      if (this.saveImages.images.length + this.saveImages.processingImages + this.saveImages.appendImages == 0) {
        this.$message('至少要有一张图片~')
        return
      }
      if (!this.bloggerId) {
        this.$message('请选择ICON！')
        return false
      }

      let params = {
        url: this.url,
        isSelf: this.isSelf == true ? 1 : 0,
        articleType: this.articleType,
        bloggerId: this.bloggerId,
        content: this.content,
        images: this.saveImages.images,
        appendImages: this.saveImages.appendImages,
        deletedImages: this.saveImages.deletedImages,
        processingImages: this.saveImages.processingImages,
        articleId: this.articleId
      }
      HttpRequest.post('/admin.php?method=blogger.doSaveArticle', params, true).then((response) => {
        if (response.data.success) {
          this.$message('修改成功')
          setTimeout(() => {
            this.$router.push({
              name: 'articleList',
              query: Object.assign({}, this.$route.query, {articleId: ''})
            })
          }, 2000)
        }
      }, (response) => {

      })
    },
    doSaveRelease () {
      this.saveArticle()
      setTimeout(() => {
        HttpRequest.post('/admin.php?method=blogger.doSaveStatus', {articleIds: [this.articleId], status: 1}).then(response => {
          if (response.data.success) {

          }
        })
      }, 1000)
    },
    goBackArticleList () {
      this.$router.push({
        name: 'articleList',
        query: Object.assign({}, this.$route.query, {articleId: ''})
      })
    },
    /**
       * 排序或取消排序
       * */
    sortImage () {
      this.isSort = !this.isSort
    },
    /**
       * 选中要添加的图片
       * */
    imageSelectClick (type, item, index) {
      setTimeout(() => {
        if (_.where(this.images, {isSelected: true}).length > 9) {
          item.isSelected = false
          this.$message('最多选择9张图片,请先将不需要的去掉勾选~')
        }
      }, 100)
    },
    /**
       * 移动图片至符合标准区域或者被过滤区域
       * */
    imageRemoveClick (type, item, index) {
      setTimeout(() => {
        if (type == 'delete') { // 移除到被清洗
          item.isSelected = false
          this.images.splice(index, 1)
          this.deletedImages.push(item)
        } else if (type == 'add') { // 加入images
          this.deletedImages.splice(index, 1)
          if (_.where(this.images, {isSelected: true}).length < 9) {
            item.isSelected = true
          } else {
            item.isSelected = false
          }
          this.images.push(item)
        }
      }, 50)
    },
    /**
       * 获取被归类的图片
       **/
    getSaveImages () {
      let images = []
      this.saveImages.deletedImages = this.deletedImages.length > 0 ? this.deletedImages : []
      _.each(this.images, (item, index) => {
        if (index < 10) {
          // 前9张图片里,选中的并且在原有images中存在归类images,选中不存在于images归类processingImages,剩余未选中归类deleteImages
          if (item.isSelected) {
            if (_.where(this.originData.images, {image: item.image}).length > 0) {
              this.saveImages.images.push(item)
            } else if (item.type == 'append' || item.type == 'appendIng') { // appendIng表示已经手动添加,但仍然在计算分数;append手动添加,还未保存计算
              this.saveImages.appendImages.push(item)
            } else {
              this.saveImages.processingImages.push(item)
            }
          } else {
            this.saveImages.deletedImages.push(item)
          }
          delete item['isSelected']
          delete item['type']
        } else {
          // 9张之后,全部归类deletedImages
          this.saveImages.deletedImages.push(item)
        }
      })
      _.each(this.saveImages.deletedImages, (item, index) => {
        delete item['isSelected']
        delete item['type']
      })
    },
    imgClassName (item) {
      if (this.isSort && item.isSelected) {
        return 'img-rel-container fleft sort-border is-active'
      } else if (this.isSort) {
        return 'img-rel-container fleft sort-border'
      } else {
        return 'img-rel-container fleft'
      }
    },
    onImagePreviewClick: onImagePreviewClick
  }
}
</script>
<style lang="less" scoped>
  .desc {
    display: flex;
    color: #000;
    font-size: 14px;
  }
  .margin-left-80 {
    margin-left: 80px
  }
  .red-font{
    color: #ff0000;
  }
  .list-wrap{
    .flex-space {
      flex-basis: 20px;
    }
    .picture-container{
      width: 500px;
      .img-rel-container{
        width: 150px;
        height: 150px;
        margin: 0 20px 40px 0;
      }
      .img-rel-wrap{
        width: 150px;
        height: 150px;
        display: inline-block;
        overflow: hidden;
        position: relative;
        border: 1px solid #ccc;
        .delete-icon{
          position: absolute;
          right: 0;
          bottom: 0;
          color: #ff0000;
          width: 40px;
          height: 30px;
          text-align: center;
          line-height: 30px;
        }
      }
      .img-rel-container:nth-child(3n){
        margin-right: 0;
      }
      .sort-border{
        border: 4px solid #ed6c63;
        width: 170px;
        padding: 5px 5px 20px 5px;
        height: 196px;
        border-radius: 10px;
      }
    }
  }
  .upload-img-tips{
    position: relative;
    top: 10px;
    color: #ff0000;
  }
  .checkbox-icon{
    width: 30px;
    height: 30px;
    display: inline-block;
    position: absolute;
    z-index: 1;
  }
  .swiper-container{
    width: 400px;
    height: 400px;
  }
  .swiper-slide{
    width: initial !important;
  }
  .cursor{
    cursor: pointer;
  }
</style>
